import React, { useEffect, useState } from 'react';
import { Image } from 'primereact/image';

const ChatTopbar = (props) => {
  return (
    <>
      <div className="chat-topbar-container">
        <div className="chat-topbar-container inner p-2 border-round-lg chatroom-surface-100">
          <div className="flex flex-row justify-content-center md:justify-content-start align-items-center gap-1">
            <Image src="/avatar/1.jpg" height="32" imageClassName="border-round-md" />
            <Image src="/avatar/0.jpg" height="32" imageClassName="border-round-md" />
            <div className="text-2xl lxgw-wenkai-mono-tc-regular">三色貓聊天室</div>
          </div>
        </div>
      </div>
    </>
  );
};
  
export default ChatTopbar;
